import { getCurrentEnvUrl } from 'configs/api/enviroments';
import {
  COVIDEO_APP_URL,
  LANDING_PAGE_URL,
  LIVE_PAGE_URL,
} from 'configs/domains/types';
import { RESELLER_IDS } from 'lib/const';
import { useAuth } from 'lib/context';
import { useMemo } from 'react';

const covideoAppDefaultUrl = process.env.REACT_APP_APPURL;
const CDK_LIVE_URL = 'https://video.connectcdk.com/live/';
const CDK_LANDING_URL = 'https://video.connectcdk.com/';

function resolveLiveUrl(
  fallback: string,
  isCDKReseller: boolean,
  liveURL?: string
): string {
  if (isCDKReseller) {
    return CDK_LIVE_URL;
  }
  if (liveURL) {
    return `${liveURL}/`;
  }
  return fallback;
}

function resloveLandingUrl(
  fallback: string,
  isCDKReseller: boolean,
  liveURL?: string
): string {
  if (isCDKReseller) {
    return CDK_LANDING_URL;
  }
  if (liveURL) {
    return `${liveURL}/`;
  }
  return fallback;
}

const getCurrentLiveUrl = (
  isCDKReseller: boolean,
  liveURL?: string
): string => {
  return getCurrentEnvUrl({
    defaultValue: LIVE_PAGE_URL.DEVELOPMENT,
    development: LIVE_PAGE_URL.DEVELOPMENT,
    sandbox: LIVE_PAGE_URL.SANDBOX,
    staging: resolveLiveUrl(LIVE_PAGE_URL.STAGING, isCDKReseller, liveURL),
    production: resolveLiveUrl(
      LIVE_PAGE_URL.PRODUCTION,
      isCDKReseller,
      liveURL
    ),
  });
};

const getCurrentCovideoUrl = (): string => {
  return getCurrentEnvUrl({
    defaultValue: COVIDEO_APP_URL.DEVELOPMENT,
    development: COVIDEO_APP_URL.DEVELOPMENT,
    staging: covideoAppDefaultUrl || COVIDEO_APP_URL.STAGING,
    sandbox: covideoAppDefaultUrl || COVIDEO_APP_URL.SANDBOX,
    sustaining: covideoAppDefaultUrl || COVIDEO_APP_URL.SUSTAINING,
    production: covideoAppDefaultUrl || COVIDEO_APP_URL.PRODUCTION,
  });
};

export const getCurrentLandingPageUrl = (
  isCDKReseller: boolean,
  landingPageURL?: string
): string => {
  return getCurrentEnvUrl({
    defaultValue: LANDING_PAGE_URL.DEVELOPMENT,
    development: LANDING_PAGE_URL.DEVELOPMENT,
    sandbox: LANDING_PAGE_URL.SANDBOX,
    sustaining: LANDING_PAGE_URL.SUSTAINING,
    staging: resloveLandingUrl(
      LANDING_PAGE_URL.STAGING,
      isCDKReseller,
      landingPageURL
    ),
    production: resloveLandingUrl(
      LANDING_PAGE_URL.PRODUCTION,
      isCDKReseller,
      landingPageURL
    ),
  });
};

export const useCurrentAppUrl = () => {
  const {
    userData: { resellerId },
    whitelabel: { liveURL, landingPageURL },
  } = useAuth();

  const isCDKReseller = resellerId?.toString() === RESELLER_IDS.CDK;

  return useMemo(
    () => ({
      livePageUrl: getCurrentLiveUrl(isCDKReseller, liveURL),
      covideoAppUrl: getCurrentCovideoUrl(),
      landingPageUrl: getCurrentLandingPageUrl(isCDKReseller, landingPageURL),
    }),
    [isCDKReseller, liveURL, landingPageURL]
  );
};
